<template>
  <div
    v-click-outside="hide"
    class="fddform-input fddform-select"
    :class="{ 'fddform-select-arrow': visible }"
    @click.stop="visible = !visible"
  >
    <button class="input">{{ label }}</button>
    <label class="use-down"></label>
    <ul v-show="visible" class="fddform-input-list">
      <slot>
        <li v-for="(item, index) in data" :key="index" class="fddform-input-list-row" @click.stop="item.handler">
          <i v-if="item.icon" :class="item.icon"></i>
          {{ item.text }}
        </li>
      </slot>
    </ul>
  </div>
</template>

<script>
  import clickOutside from '../../utils/clickoutside'

  export default {
    name: 'FddDropdown',
    directives: { clickOutside },
    props: {
      // 按钮文本
      label: {
        type: String,
        default: '更多'
      },

      // 列表数据: [{ text: '名称', icon: '图标', handler: '点击操作'}, ...]
      data: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        visible: false
      }
    },

    mounted() {
      this.button = this.$el.querySelector('button.input')
    },

    methods: {
      hide() {
        this.visible = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .fddform-select {
    display: inline-block;

    .fddform-input-list {
      font-size: 14px;
    }
  }
</style>
